<script lang="ts" setup>
import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'
import newMiscDemoGreetingCardIcon from '@consumer/assets/icons/new-misc/demo-greeting-card.svg?svgicon'

const { gift, complementaryBgColor } = $(useRecipientLanding())

const color = computed(() => gift.giftlyMetadata?.greetingCardColor ?? complementaryBgColor)
</script>

<template>
  <GIcon
    :svg="newMiscDemoGreetingCardIcon"
    style="height: 360px; width: 270px;"
    :style="{
      fill: color,
      color: color,
    }"
  />
</template>
